import SimpleGrid from "./SimpleGrid";

export default SimpleGrid;
